<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-10 19:02 -->
<!-- Description:  -->
<template>
  <div>
    <MenuForm :content="reg" :key="reg.id"
      @saved="handlerSave($event)"></MenuForm>
  </div>
</template>
<script>
import AdminService from "../AdminService.js";
import MenuForm from "./MenuForm.vue";

// script content
export default {
  name: "MenuFormView",
  components: {
    MenuForm,
  },

  // directives

  props: {
    id: {
      default: null,
    }
  },

  data: () => ({
    reg: {},
  }),

  computed: {
    //
  },

  // watch: {},

  async mounted() {
    if(this.id) {
      let reg = await AdminService.getMenu(this.id);
      this.reg = reg;
    }
  },

  methods: {
    handlerSave(reg) {
      if(!this.id) {
        this.$router.push({
          name: "admin.menu-edit",
          params: { id: reg.id }
        });
      }
    }
    //
    //
  }
};
</script>
<style scoped></style>

